import { Autocomplete, TextField } from '@mui/material';
import { Field } from 'src/API';
import { FieldInput } from 'src/api/process-module';
import { forceString } from 'src/utils/forceString';

interface CheckboxListFieldProps {
  field: FieldInput & Partial<Field>;
  index: number;
  handleFieldChange: (index: number, field: Partial<FieldInput & Partial<Field>>) => void;
  isSubmitting: boolean;
  isUsingExistingField: boolean;
}

export const CheckboxListField = ({
  field,
  index,
  handleFieldChange,
  isSubmitting,
  isUsingExistingField,
}: CheckboxListFieldProps) => {
  return (
    <>
      <Autocomplete
        multiple
        freeSolo
        options={field.dataSource ? JSON.parse(forceString(field.dataSource)) : []}
        value={field.dataSource ? JSON.parse(forceString(field.dataSource)) : []}
        onChange={(_, newValues) => {
          // Filter out duplicates based on name/label
          const uniqueValues = newValues.reduce(
            (acc, value) => {
              const valueToCheck = typeof value === 'string' ? value.trim() : value.name || value.label;
              if (!acc.some((item) => (typeof item === 'string' ? item : item.name || item.label) === valueToCheck)) {
                acc.push(value);
              }
              return acc;
            },
            [] as (string | { name: string; label: string })[],
          );

          handleFieldChange(index, {
            dataSource: JSON.stringify(
              uniqueValues.map((value) =>
                typeof value === 'string' ? { name: value.trim(), label: value.trim() } : value,
              ),
            ),
          });
        }}
        getOptionLabel={(option) => (typeof option === 'string' ? option : option.label || option.name)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Options"
            placeholder="Type and press enter"
            helperText="Type an option and press enter to add it"
            required
          />
        )}
        disabled={isSubmitting || isUsingExistingField}
      />
    </>
  );
};
